/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_CronsInputs */

const en_marketing_surface_crons = /** @type {(inputs: Marketing_Surface_CronsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crons`)
};

const es_marketing_surface_crons = /** @type {(inputs: Marketing_Surface_CronsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crons`)
};

const fr_marketing_surface_crons = /** @type {(inputs: Marketing_Surface_CronsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crons`)
};

/**
* | output |
* | --- |
* | "Crons" |
*
* @param {Marketing_Surface_CronsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_crons = /** @type {((inputs?: Marketing_Surface_CronsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_CronsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_crons(inputs)
	if (locale === "es") return es_marketing_surface_crons(inputs)
	return fr_marketing_surface_crons(inputs)
});